import { useEffect, useRef } from 'react';
import env from '../utils/env';

const isReady = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.grecaptcha !== 'undefined' &&
  typeof window.grecaptcha.enterprise === 'object' &&
  typeof window.grecaptcha.enterprise.render === 'function';

const renderRecaptcha = (
  elementId: string,
  action: string,
  onChange: (response: string) => void,
  onExpired?: () => void
): void => {
  const sitekey = env.recaptchaKey.getOrElse(() => '');
  const callback = (response: string) => {
    onChange(response);
  };
  window.grecaptcha.enterprise.render(elementId, {
    sitekey,
    action,
    callback,
    'expired-callback': onExpired
  });
};

type Props = {
  elementId: string;
  action: string;
  onReady: () => void;
  onChange: (response: string) => void;
  onExpired?: () => void;
};

const Recaptcha = ({
  elementId,
  action,
  onReady,
  onChange,
  onExpired
}: Props) => {
  const rendered = useRef(false);
  useEffect(() => {
    const handler = setInterval(() => {
      if (isReady() && !rendered.current) {
        rendered.current = true;
        renderRecaptcha(elementId, action, onChange, onExpired);
        onReady();
        clearInterval(handler);
      }
    }, 1000);
    return () => {
      clearInterval(handler);
    };
  }, []);
  return <div id={elementId} />;
};

export default Recaptcha;
